import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CHA005_Request,
  IAPI_CHA005_Response,
} from "../../../type/apiType";

// チャットボットシーケンス参照
const httpAPI_CHA005 = async (
  param: IAPI_CHA005_Request
): Promise<IAPI_CHA005_Response> => {
  let res = await http.post(ApiUrl.API_CHA005, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CHA005 };
